import { createClient } from "@connectrpc/connect";
import { ClaimsService } from "@reliquo/proto/claims/connect";
import { createTransport } from "./transport";

/**
 * Returns a typed ConnectRPC ClaimsService client with the given access token
 * injected as a Bearer header.
 */
export function getClaimsClient(accessToken: string | null) {
  return createClient(ClaimsService, createTransport(accessToken));
}
